import {
    InvDetailHistoryElementType,
    InvDetailHistoryMapType,
    InvDetailHistorySearchParamType,
    InvDetailType
} from "../interface";

export const invDetailInit: InvDetailType = {
    inventoryId: 0,
    inventoryUnit: 0,
    safetyAmount: 0,
    inventoryAmount: 0,
    newInventoryAmount: 0,
    originalPrice: 0,
    sellingPrice: 0,
    barcode: "",
    newErpProductid: "",
    newTxtNmItem: "",
    createdon: "",
    nameOfCreator: "",
    vendor: "",
    category: "",
    newTxtStndItem: "",
    newTxtCdItem: "",
    majorCategory: "",
    subCategory: "",
    productRange: "",
    erpProductImageVO: {}
};

export const invDetailHistorySearchParamInit: InvDetailHistorySearchParamType = {
    adjustmentFlag: true,
    incomingFlag: true,
    inventoryId: 0,
    limit: 10,
    outgoingFlag: true,
    pageNo: 1
}

export const invDetailHistoryElementInit: InvDetailHistoryElementType = {
    inventoryChangeId: 0,
    changeType: "",
    accountName: "",
    changeAmount: 0,
    changeLog: "",
    memo: "",
    fullname: "",
    modAt: "",
}

export const invDetailHistoryMapInit: InvDetailHistoryMapType = {
    inventoryDetailHistoryRes: {inventoryDetailEachHistoryResList: []},
    totalCount: 0,
}